import { render, staticRenderFns } from "./GetCommission.vue?vue&type=template&id=0b06bea5&scoped=true&"
import script from "./GetCommission.vue?vue&type=script&lang=js&"
export * from "./GetCommission.vue?vue&type=script&lang=js&"
import style0 from "./GetCommission.vue?vue&type=style&index=0&id=0b06bea5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06bea5",
  null
  
)

export default component.exports